import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { combineLatest, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';

type AppKey = 'aquaculture' | 'wild-harvest';

const EMPTY_NAVIGATION: Navigation = {
  default: [],
  compact: [],
  futuristic: [],
  horizontal: [],
};

export const initialDataResolver = (route: ActivatedRouteSnapshot) => {
  const navigationService = inject(NavigationService);
  const notificationsService = inject(NotificationsService);

  const appKey = route.data?.['appKey'] as AppKey | undefined;

  return combineLatest([
    navigationService.get(appKey).pipe(
      take(1),
      catchError((error) => {
        console.error('[Resolver] navigation failed', error);
        return of(EMPTY_NAVIGATION);
      }),
    ),
    notificationsService.getAll().pipe(
      take(1),
      catchError((error) => {
        console.error('[Resolver] notifications failed', error);
        return of([]);
      }),
    ),
  ]).pipe(take(1));
};
